import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/projectConfigs',
        name: 'projectConfigs',
        meta: { sideMenuLabel: "Configurazione progetto" },
        component: () => import("./views/projectConfigDetail.vue")
    },
];

export default routes;